import { database } from 'lib_ui-services';

export default {
    verb: 'doingRemove',
    namespace: 'application',
    relation: 'notification',
    description: 'Remove the requested record from the database',
    //this is the actual logic:
    logic
};

/**
 * @typedef {import("rulesengine.io").LoggingProvider} LoggingProvider
 * @typedef {import("rulesengine.io").Context} Context
 */

/**
 * @param {{
 *   data: T;
 *   prerequisiteResults: object[];
 *   context: Context;
 *   dispatch: (data:object,context:Context,awaitResult?:boolean)=>Promise<void|any>
 *   log: LoggingProvider
 * }} parameters
 * @returns {T}
 */
async function logic({ data, context }) {
    const db = database.get();
    const result = await db.remove(data, context);
    return { ...data, result };
}
